<template>
  <div class="round-record-parts">
    <dl class="round-record-parts__record">
      <dt class="round-record-parts__record-title" v-text="title" />
      <dd
        class="round-record-parts__record-value"
        :class="{ hidden: title === 'RACE' || title === 'QUALIFYING' }"
        v-text="value"
      />
    </dl>

    <div class="round-record-parts__position">
      <trophy-icon-parts
        v-if="position && position < 4"
        class="round-record-parts__position__icon"
        :position="position"
      />
      <span class="round-record-parts__position__value" v-text="displayPosition" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import TrophyIconParts from '@/components/StandingsPage/common/parts/TrophyIconParts.vue'

export type RoundRecordDataType = {
  title: string
  record: string
  position: number
}

/**
 * Standings: レース詳細 各レコード パーツ
 */
export default defineComponent({
  name: 'RoundRecordParts',
  components: {
    TrophyIconParts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    /** 表示用の順位 */
    const displayPosition = computed(() => (props.position ? String(props.position) : '---'))

    return {
      displayPosition,
    }
  },
})
</script>

<style lang="scss" scoped>
.round-record-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: min(#{convertPXtoVW(10), 10px}) min(#{convertPXtoVW(28), 28px})
    min(#{convertPXtoVW(10), 10px}) min(#{convertPXtoVW(20), 20px});
  color: $black;

  &__record {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-items: flex-start;
    gap: min(#{convertPXtoVW(2)}, 2px);
    width: calc(100% - min(#{convertPXtoVW(40)}, 40px));

    &-title {
      font-weight: 600;
      font-size: min(#{convertPXtoVW(14)}, 14px);
      line-height: 1.43;
      letter-spacing: 0.02em;
    }

    &-value {
      font-weight: 500;
      font-size: min(#{convertPXtoVW(13)}, 13px);
      line-height: 1.54;
      letter-spacing: 0.04em;

      &.hidden {
        visibility: hidden;
      }
    }
  }

  &__position {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: min(#{convertPXtoVW(3)}, 3px);
    width: min(#{convertPXtoVW(40)}, 40px);
    font-weight: 600;
    font-size: min(#{convertPXtoVW(16)}, 16px);
    line-height: 1.25;
    text-align: right;
    letter-spacing: 0.04em;
  }
}
</style>
